import { render, staticRenderFns } from "./InicioTres.vue?vue&type=template&id=584d8da5&scoped=true"
import script from "./InicioTres.vue?vue&type=script&lang=js"
export * from "./InicioTres.vue?vue&type=script&lang=js"
import style0 from "./InicioTres.vue?vue&type=style&index=0&id=584d8da5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d8da5",
  null
  
)

export default component.exports